import GTextField, { IGTextFieldProps } from "./GTextField";

export default function GIntegerField(props:IGTextFieldProps) {
    const onFormat = (val:string) => val.replace(/[^\d]/g, "")
    return <GTextField {...props} formatter={onFormat}/>    
}